export type SupervisionSection = "live" | "flagged" | "insights";

export const SUPERVISION_SECTION_STORAGE_KEY = "supervision.section";
